// import { InputFactory } from "nq-component";
import InputFactory from "../../../../../components/InputFactory";
import BaseFormPage from "../../../../../base/BaseFormPage";
import { upsertUseCase as createUpsertUseCase } from "../../../../../usecases/object";
import FormFactory from "../../../../../components/FormFactory";
import ResidentialAddressSelector from "./ResidentialAddressSelector";
import PermanentAddressSelector from "./PermanentAddressSelector";
import EmployeeFormPresenter from "../../employee-form/EmployeeFormPresenter";

export default class PersonalInfo extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new EmployeeFormPresenter(this);
  }

  getCollectionName() {
    return "employees";
  }

  handleNext() {
    const object = this.props.object;
    const inputValue = this.presenter.createInputValue(object);
    this.setObject(inputValue);
    this.props.onChangeTab();
  }

  upsertUseCase() {
    return createUpsertUseCase();
  }

  handleSubmit() {
    if (this.props.isSubmitting) return;

    const presenter = this.props.presenter || this.presenter;
    const object = this.props.object;
    const inputValue = presenter.createInputValue(object);

    presenter.showDialogSubmit(inputValue);
  }

  setObject(object) {
    const presenter = this.props.presenter || this.presenter;
    const newObj = presenter.mirrorResidentialToPermanent({
      ...this.props.object,
      ...object,
    });
    if (this.presenter) {
      this.presenter.object = newObj;
    }
    this.props.setObject(newObj);
    return newObj;
  }

  render() {
    const { object } = this.props;
    const isSameAsResidential = Boolean(object.bool);
    // const schema = this.getSchema(this.getCollectionName());
    const schema = this.props.schema;
    return (
      <>
        {/* <Divider icon={"bi bi-person"} title={"Personal Information"} /> */}
        {/* data */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (this.state.someCondition) {
              this.handleSubmit(); // Your custom submit logic
            } else {
              this.handleNext(); // Your custom next logic
            }
          }}
          id="myForm"
        >
          <div className="row">
            <FormFactory
              className="col-lg-4 p-1"
              schema={schema}
              showTabs={false}
              object={object}
              onChange={this.onChange.bind(this)}
              // excludeFields={fields}
            />
          </div>
          <div className="mt-4">
            <p className="small fw-bold mb-0 ms-1">Residential Address</p>
            <hr />
          </div>

          <ResidentialAddressSelector
            onLocationChange={(data) => {
              this.setObject(data);
            }}
            object={object}
          />
          <div className="row">
            <div className="col-lg-4 p-1">
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                House/ Block/ Lot No.
                <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                field="residentialHouseNo"
                label="House Number"
                required={true}
                object={object}
                onChange={this.onChange.bind(this)}
              />
            </div>
            <div className="col-lg-4 p-1">
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Zip Code
                <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                field="residentialZipCode"
                label="House Number"
                required={true}
                object={object}
                onChange={this.onChange.bind(this)}
              />
            </div>
          </div>
          <div className="mt-4">
            <p className="small fw-bold mb-0 ms-1">Permanent Address</p>
            <hr />
          </div>
          <div className="column d-flex w-100">
            <InputFactory
              type="Boolean"
              field="bool"
              label="Same As Residential Address"
              object={object}
              onChange={this.onChange.bind(this)}
            />
          </div>

          <fieldset disabled={isSameAsResidential}>
            <PermanentAddressSelector
              onLocationChange={(data) => {
                this.setObject(data);
              }}
              disabled={isSameAsResidential}
              object={object}
            />
            <div className="row">
              <div className="col-lg-4 p-1">
                <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                  House/ Block/ Lot No.
                  <span style={{ color: "red" }}>*</span>
                </label>
                <InputFactory
                  type="String"
                  field="permanentHouseNo"
                  required={!isSameAsResidential}
                  disabled={isSameAsResidential}
                  label="House Number"
                  object={object}
                  onChange={this.onChange.bind(this)}
                />
              </div>
              <div className="col-lg-4 p-1">
                <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                  Zip Code
                  <span style={{ color: "red" }}>*</span>
                </label>
                <InputFactory
                  type="String"
                  field="permanentZipCode"
                  label="House Number"
                  required={!isSameAsResidential}
                  disabled={isSameAsResidential}
                  object={object}
                  onChange={this.onChange.bind(this)}
                />
              </div>
            </div>
          </fieldset>

          <div className="mt-4 d-flex justify-content-end">
            <div className="border" style={{ borderRadius: "4px" }}>
              <button
                style={{
                  borderRadius: "4px 0 0 4px",
                  backgroundColor: "#29457c",
                }}
                type="submit"
                disabled={this.props.isSubmitting}
                onClick={() => {
                  this.setState({ someCondition: true });
                }}
                className="btn btn-primary fs-sm me-0"
              >
                {this.props.isSubmitting ? "Saving..." : "Submit"}
              </button>
              <button
                style={{ borderRadius: "0", backgroundColor: "#fff" }}
                type="button"
                className="btn btn-light fs-sm me-0"
                onClick={() => this.props.onClickBack()}
              >
                Cancel
              </button>

              <button
                style={{
                  borderRadius: " 0 4px 4px 0",
                  backgroundColor: "#29457c",
                }}
                type="submit"
                onClick={() => {
                  this.setState({ someCondition: false });
                }}
                className="btn btn-primary fs-sm me-0 "
              >
                Next
              </button>
            </div>
          </div>
        </form>
      </>
    );
  }
}
